import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableSortLabel from '@material-ui/core/TableSortLabel';

class TableHeader extends PureComponent {

  static propTypes = {
    columns: PropTypes.array.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    hideOptions: PropTypes.bool
  };

  createSortHandler = (property) => (event) => {
    this.props.onRequestSort(event, property);
  };

  renderSortable(column) {
    const { classes, order, orderBy } = this.props;
    return (
      <TableSortLabel
        active={orderBy === column.key}
        direction={order}
        classes={{
          icon: ((orderBy === column.id) ? classes.activeSortIcon : classes.inactiveSortIcon ) 
        }}                
        onClick={this.createSortHandler(column.key)}
      >
        <span type="tableHeader">{column.header || column.label}</span>
      </TableSortLabel>
    );
  }

  renderDeleteHeader() {
    const { classes } = this.props;
    return (
      <TableCell className={classes.cell} padding="none">{''}</TableCell>
    );
  }

  render() {
    const { classes, order, hideOptions, columns } = this.props;

    return (
      <TableHead>
        <TableRow className={classes.row}>
          {columns.map(column => {
            const key = column.options && column.options.header ? column.options.header : column.key;

            if (column.options && column.options.hide === true) return null;

            return (
              <TableCell 
                key={key}
                align={column.numeric ? 'right' : column.options.align || 'inherit'}
                className={classes.cell}
                style={column.style ? column.style : null}
                sortDirection={column.sortable ? order : false}
              >
                {!column.hide && (column.sortable ?
                  this.renderSortable(column) :
                  <span type="tableHeader">{column.header || column.label}</span>)
                }
              </TableCell>
            );
          }, this)}
          {!hideOptions && <TableCell key="table-cell-menu" className={classes.menu} />}
        </TableRow>
      </TableHead>
    );
  }
}

const styles = theme => ({
  row: { 
    height: 20,
    padding: 0,
  },
  cell: {
    height: 20,
    padding: '0px 0px 10px 0px',
  },
  activeSortIcon: {
    color: theme.palette.primary.main,
    opacity: 1,
  },
  inactiveSortIcon: {
    color: theme.palette.primary.main,
    opacity: 0.4,
  },
  menu: {
    width: 20,
    padding: 0,
  },
});

export default withStyles(styles)(TableHeader);
